import PlanboardMode from './PlanboardMode'
import PlanboardModeChooseDeal from '@/components/planboard/PlanboardModeChooseDeal'

export default class PlanboardModeIdle extends PlanboardMode {
  start() {
    var planboard = this.planboard
    // Cancel slots selection
    planboard.$newBookingButtons.hide()
    planboard.$defaultButtons.show()
    planboard.$elm.find('.planboard-slot.selected').removeClass('selected')
    planboard.$activityRows.removeClass('planboard__activity--dimmed')
    planboard.trigger('planboard.slots-changed')
    this.waitingSlot = null
    this.planboard.resetWrapperHeight()
    this.planboard.productGroups = []

    const $buttons = $(
      '[data-planboard-action="planner.submit"], [data-planboard-action="bookselection"]',
    )
    $buttons.text('Create booking')
  }

  slotClick($slot, evt) {
    return
  }

  onChoosePackage() {
    PlanboardModeChooseDeal.prototype.onChoosePackage.apply(this, arguments)
  }
}
